import { CEViewAttributesBase } from './ce-view-attributes-base'


export class CEViewAttributes extends CEViewAttributesBase {

}